import { useState, type FormEvent } from "react";
import { api } from "@/lib/api";
import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Card, CardBody } from "@/components/ui/card";
import { LumosLogo } from "@/components/brand/LumosLogo";
import { Spinner } from "@/components/ui/spinner";
import { TextField } from "@/components/app/page";

export default function Login({ onSuccess }: { onSuccess: (token: string) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { token } = await api.login(email, password);
      onSuccess(token);
    } catch (err) {
      setError(err instanceof Error && err.message === "INVALID_CREDENTIALS" ? "Неверная почта или пароль" : "Ошибка входа");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-background grid min-h-dvh place-items-center p-6">
      <Card className="w-full max-w-sm">
        {/* The wordmark is white, so it sits on the rail's navy rather than the card. */}
        <div className="grid place-items-center gap-2 rounded-t-[inherit] bg-[var(--sidebar)] px-6 py-7">
          <LumosLogo className="h-8 w-auto" />
          <span className="text-xs text-white/75">Maxima · вход для администраторов</span>
        </div>
        <CardBody>
          <form onSubmit={submit} className="flex flex-col gap-4">
            <TextField label="Логин" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <TextField
              label="Пароль"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {error && (
              <Alert color="destructive" size="sm">
                {error}
              </Alert>
            )}
            <Button type="submit" disabled={busy} className="w-full">
              {busy && <Spinner />}
              {busy ? "Вход…" : "Войти"}
            </Button>
          </form>
        </CardBody>
      </Card>
    </div>
  );
}
